import { createCodec, CODEC_TYPES } from "../codec.js";
export function message(encode, decode, stream) {
    return createCodec('message', CODEC_TYPES.LENGTH_DELIMITED, encode, decode, stream);
}
//# sourceMappingURL=message.js.map